// AI Configuration Hub Constants
// Place in: /components/settings/aiconfigurationhub/constants.js

export const toneOptions = [
  'Friendly & Casual',
  'Assertive & Confident',
  'Aggressive & Bold',
  'Neutral & Professional',
  'Empathetic & Supportive'
];

export const initialPersonaOptions = [
  'Icebreaker / Intro',
  'Lead Qualifier',
  'FAQ Assistant',
  'Information Gatherer',
  'First Contact Specialist'
];

export const engagementPersonaOptions = [
  'Nurturer',
  'Appointment Setter',
  'Closer',
  'Relationship Builder',
  'Follow-up Specialist',
  'Objection Handler'
];

export const followupPersonaOptions = [
  'Gentle Reminder',
  'Value Provider',
  'Urgency Creator',
  'Relationship Builder',
  'Closing Specialist',
  'Final Attempt'
];

export const strategyTemplates = [
  {
    id: 'consultative',
    name: 'Consultative Sales',
    description: 'Relationship-first approach with value-driven messaging',
    icon: '🤝',
    industry: 'B2B SaaS',
    avgConversion: '14.2%',
    followupCount: 3,
    timeline: '21 days',
    // Legacy display fields (not used for wiring)
    tone: 'Professional & Consultative',
    persona: 'Trusted Advisor',
    // Mapped to actual option values
    initialTone: 'Friendly & Casual',
    initialPersona: 'First Contact Specialist',
    engagementTone: 'Neutral & Professional',
    engagementPersona: 'Relationship Builder',
    followups: [
      { tone: 'Friendly & Casual',        persona: 'Gentle Reminder' },
      { tone: 'Neutral & Professional',   persona: 'Value Provider' },
      { tone: 'Empathetic & Supportive',  persona: 'Relationship Builder' },
    ],
  },
  {
    id: 'aggressive_sales',
    name: 'High-Velocity Sales',
    description: 'Fast-paced, conversion-focused with urgency triggers',
    icon: '🎯',
    industry: 'Enterprise',
    avgConversion: '18.3%',
    followupCount: 3,
    timeline: '14 days',
    tone: 'Assertive & Confident',
    persona: 'Closer',
    initialTone: 'Assertive & Confident',
    initialPersona: 'Lead Qualifier',
    engagementTone: 'Assertive & Confident',
    engagementPersona: 'Closer',
    followups: [
      { tone: 'Assertive & Confident', persona: 'Urgency Creator' },
      { tone: 'Aggressive & Bold',     persona: 'Closing Specialist' },
      { tone: 'Assertive & Confident', persona: 'Final Attempt' },
    ],
  },
  {
    id: 'gentle_nurture',
    name: 'Long-term Nurture',
    description: 'Patient relationship building with educational content',
    icon: '🌱',
    industry: 'Healthcare',
    avgConversion: '9.1%',
    followupCount: 3,
    timeline: '45 days',
    tone: 'Empathetic & Supportive',
    persona: 'Educator',
    initialTone: 'Empathetic & Supportive',
    initialPersona: 'Information Gatherer',
    engagementTone: 'Empathetic & Supportive',
    engagementPersona: 'Nurturer',
    followups: [
      { tone: 'Empathetic & Supportive', persona: 'Gentle Reminder' },
      { tone: 'Empathetic & Supportive', persona: 'Value Provider' },
      { tone: 'Friendly & Casual',       persona: 'Relationship Builder' },
    ],
  },
];

export const defaultFollowups = [
  {
    id: 1,
    day: 3,
    type: 'gentle_reminder',
    tone: '',
    persona: '',
    enabled: true
  },
  {
    id: 2,
    day: 7,
    type: 'value_add',
    tone: '',
    persona: '',
    enabled: true
  },
  {
    id: 3,
    day: 14,
    type: 'final_attempt',
    tone: '',
    persona: '',
    enabled: true
  }
];